import { NavbarComponent } from "./components/shared/navbarComponent";
import { Main } from "./components/main/main";

function App() {
  return (
    <div>
      <NavbarComponent />
      <Main />
    </div>
  );
}

export default App;
